<app-summary-collections-chart [summaryCollectionsData]="summaryData" [showProgressBar]="loadingIndicator">
</app-summary-collections-chart>
<app-summary-collections-table [summaryCollectionsData]="summaryData" [dateRange]="dateRange"
                               [showProgressBar]="loadingIndicator"
></app-summary-collections-table>
